import { FC, useCallback } from 'react';

import { IoCameraSharp } from 'react-icons/io5';
import Button from 'ui/components/common/Button';
import { Uploader } from 'ui/components/form';
import useModal from 'ui/partials/Modal/useModal';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';

import Avatar from './Avatar';

interface PROPS {
  // TODO: add User interface
  user?: any;
  className?: string;
  showTextButton?: boolean;
  onSubmit: (file: string) => void;
  isLoading?: boolean;
  disabled?: boolean;
  buttonLabel?: string;
  company?: boolean;
}

const AvatarUploader: FC<PROPS> = ({
  user,
  className,
  showTextButton = false,
  onSubmit,
  isLoading = false,
  disabled,
  buttonLabel = 'UPLOAD PROFILE IMAGE',
  company,
}) => {
  const { showModal } = useModal();

  const handleShowModal = useCallback(() => {
    if (disabled) return;

    showModal({
      title: 'Upload Photo',
      hideHeader: true,
      size: SIZE.Small,
      content: (
        <Uploader
          defaultImage={user?.photoUrl}
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
      ),
    });
  }, [disabled, user, isLoading, onSubmit, showModal]);

  return (
    <div
      className={cn(
        'relative h-fit cursor-pointer focus:outline-none',
        'flex flex-col items-center justify-center',
      )}
      onClick={handleShowModal}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}
    >
      <Avatar
        company={company}
        user={user}
        className={cn(className)}
        size={SIZE.Large}
      />
      {showTextButton && (
        <Button
          label={buttonLabel}
          className="mt-4 font-semibold"
          intent="link"
          onClick={handleShowModal}
          disabled={disabled}
          expiredSubscription={disabled}
        />
      )}
      <div
        className={cn(
          'absolute top-0 h-[52px] w-[52px]',
          'rounded-full bg-[#11334C60]',
          'opacity-0 hover:opacity-100',
          'flex items-center justify-center',
          className,
        )}
      >
        <IoCameraSharp className="text-fill-tertiary h-6 w-6" />
      </div>
    </div>
  );
};

export default AvatarUploader;
